import React, { Component } from "react";
import Dropzone from "react-dropzone";
import LocaleStrings from "Languages";

export default class LessonAudioFilesDrop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filepath: props.filepath,
    };
    this.resetImage = this.resetImage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      if (nextProps.filepath !== "" && this.state.filepath === "") {
        this.setState({ filepath: nextProps.filepath });
      }
    }
  }

  onDropFile = (files) => {
    var that = this;
    let file = files[0];

    let reader = new FileReader();
    reader.onloadend = () => {
      var item = reader.result;
      var data = { file: item, filename: file.name.replace(/ /g, "-") };
      that.props.onFileSave(data);
      that.props.onFileChnageLocally(true);
    };
    reader.readAsDataURL(file);
  };

  resetImage = () => {
    this.setState({ filepath: "" });
    this.props.onFileSave("");
    this.props.onFileChnageLocally(true);
  };

  render() {
    let fileUrl = this.state.filepath;
    let { fileName, fileOld } = this.props;

    var hideDropZoneClass = "";
    var hideControlButton = "hide-feature";

    if (fileUrl && fileUrl !== "file object not found") {
      hideDropZoneClass = "hide-feature";
      hideControlButton = "";
    }

    return (
      <div className="pointer">
        <Dropzone onDrop={this.onDropFile} accept="audio/*" multiple={false}>
          <div className={`${this.props.className} ${hideDropZoneClass}`}>
            <img
              className="file-icon"
              src="../../style/images/audio_file_icon_xs.png"
              alt=""
            />
            <span>
              <div className="custom-placeholder">
                {LocaleStrings.course_lesson_form_ph_lesson_cover_audio}
              </div>
            </span>
            <button
              type="button"
              className="btn h-35px float-right btn-custom-blue"
            >
              {LocaleStrings.select_file}
            </button>
          </div>
        </Dropzone>

        <div className={`lesson-audio-displaybox ${hideControlButton}`}>
          <img
            className="file-icon"
            src="../../style/images/audio_file_icon_xs.png"
            alt=""
          />
          <span>
            <div className="custom-text1">{fileName}</div>
          </span>
          <img
            onClick={this.resetImage}
            className="file-delete-button"
            src="../../style/images/trash_icon_xs.png"
            alt=""
          />
        </div>
      </div>
    );
  }
}
